import { http } from '@/app/lib/http/client'

export interface ExpenseConcept {
  id: number
  name: string
}

export interface ExpenseItem {
  id: number
  concept_id: number
  expense_date: string
  amount: string | number
  concept: ExpenseConcept
}

export interface ExpenseFilters {
  search?: string
  date_from?: string
  date_to?: string
  page?: number
  per_page?: number
}

export interface ExpensePaginator {
  current_page: number
  data: ExpenseItem[]
  from: number | null
  to: number | null
  per_page: number
  total: number
}

export interface ExpenseApiResponse<T> {
  success: boolean
  message: string
  data: T
}

export interface ExpensePayload {
  concept_id: number
  expense_date: string
  amount: number
}

export interface ExpenseConceptPayload {
  name: string
}

export interface ExpenseService {
  getExpenses(filters?: ExpenseFilters): Promise<ExpenseApiResponse<ExpensePaginator>>
  createExpense(payload: ExpensePayload): Promise<ExpenseApiResponse<ExpenseItem>>
  updateExpense(id: number, payload: ExpensePayload): Promise<ExpenseApiResponse<ExpenseItem>>
  deleteExpense(id: number): Promise<ExpenseApiResponse<null>>
  getConcepts(): Promise<ExpenseApiResponse<ExpenseConcept[]>>
  createConcept(payload: ExpenseConceptPayload): Promise<ExpenseApiResponse<ExpenseConcept>>
  updateConcept(
    id: number,
    payload: ExpenseConceptPayload,
  ): Promise<ExpenseApiResponse<ExpenseConcept>>
  deleteConcept(id: number): Promise<ExpenseApiResponse<null>>
}

export const expenseService: ExpenseService = {
  async getExpenses(filters) {
    const response = await http.get('/expenses', { params: filters })
    return response.data
  },

  async createExpense(payload) {
    const response = await http.post('/expenses', payload)
    return response.data
  },

  async updateExpense(id, payload) {
    const response = await http.put(`/expenses/${id}`, payload)
    return response.data
  },

  async deleteExpense(id) {
    const response = await http.delete(`/expenses/${id}`)
    return response.data
  },

  async getConcepts() {
    const response = await http.get('/expense-concepts')
    return response.data
  },

  async createConcept(payload) {
    const response = await http.post('/expense-concepts', payload)
    return response.data
  },

  async updateConcept(id, payload) {
    const response = await http.put(`/expense-concepts/${id}`, payload)
    return response.data
  },

  async deleteConcept(id) {
    const response = await http.delete(`/expense-concepts/${id}`)
    return response.data
  },
}
